/* eslint-disable */
// 防抖
export function debounce(func, wait, immediate) {
  var timeout, result;
  var debounced = function () {
    var context = this;
    var args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过，不再执行
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) result = func.apply(context, args)
    }
    else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
    return result;
  };

  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
}

// 节流
/* 
    三种用法
    throttle(func, wait)
    throttle(func, wait, {leading: false})
    throttle(func, wait, {trailing: false})
*/
export function throttle(func, wait, options) {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function () {
    previous = options.leading === false ? 0 : +new Date();
    timeout = null;
    func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function () {
    var now = +new Date();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
  };

  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = null;
  };

  return throttled;
}

// 数组去重
/* 
  isSorted 是否已经排序
  iteratee 一个函数，可以对每个元素进行重新计算
*/
export function unique(array, isSorted, iteratee) {
  var res = [];
  var seen = [];

  for (var i = 0; i < array.length; i++) {
    var value = array[i];
    var computed = iteratee ? iteratee(value, i, array) : value;
    if (isSorted) {
      if (i === 0 || seen !== computed) {
        res.push(value);
      }
      seen = computed;
    } else if (iteratee) {
      if (seen.indexOf(computed) === -1) {
        seen.push(computed);
        res.push(value);
      }
    } else if (res.indexOf(value) === -1) {
      res.push(value);
    }
  }
  return res;
}

// 数组去重ES5,支持对象数组,这种是最强的去重
export function uniqueES5 (array) {
  let obj = {};
  return array.filter(item => obj.hasOwnProperty(typeof item + JSON.stringify(item)) ? false : obj[typeof item + JSON.stringify(item)] = true)
}

// 数组去重ES6, 不支持对象数组
export const uniqueES6 = (array) => [...new Set(array)];

// 判断数据类型方法 typeof + Object.prototype.toString.call()
var class2type = {};
// 生成 class2type 映射
'Boolean Number String Function Array Date RegExp Error Null Undefined'.split(' ').map(item => {
  class2type[`[object ${item}]`] = item.toLowerCase();
})

export function type (obj) {
  // 解决IE6 null也是object的问题
  if (obj === null) {
    return obj + '';
  }
  return typeof obj === 'object' || typeof obj === 'function' ? class2type[Object.prototype.toString.call(obj)] || 'object' : typeof obj;
}


// WEBPACK FOOTER //
// ./src/utils/underscore.js